export default {
  // Get last live video
  GET_STUDENT_LAST_LIVE_VIDEO_REQUEST: "GET_STUDENT_LAST_LIVE_VIDEO_REQUEST",
  GET_STUDENT_LAST_LIVE_VIDEO_SUCCESS: "GET_STUDENT_LAST_LIVE_VIDEO_SUCCESS",
  GET_STUDENT_LAST_LIVE_VIDEO_FAIL: "GET_STUDENT_LAST_LIVE_VIDEO_FAIL",

  // Save live video seen
  SAVE_STUDENT_LIVE_VIDEO_SEEN_REQUEST: "SAVE_STUDENT_LIVE_VIDEO_SEEN_REQUEST",
  SAVE_STUDENT_LIVE_VIDEO_SEEN_SUCCESS: "SAVE_STUDENT_LIVE_VIDEO_SEEN_SUCCESS",
  SAVE_STUDENT_LIVE_VIDEO_SEEN_FAIL: "SAVE_STUDENT_LIVE_VIDEO_SEEN_FAIL",

  // Loading state
  STUDENT_LIVE_VIDEOS_LOADING: "STUDENT_LIVE_VIDEOS_LOADING",
}; 